export default "__VITE_ASSET__CSqhEm8O__"